// Chess Clock page
let whiteTime = 300; // seconds
let blackTime = 300;
let increment = 0;
let activeSide: 'w' | 'b' | null = null;
let clockInterval: ReturnType<typeof setInterval> | null = null;
let isRunning = false;

const PRESETS = [
  { name: '1+0', time: 60, inc: 0 },
  { name: '2+1', time: 120, inc: 1 },
  { name: '3+0', time: 180, inc: 0 },
  { name: '3+2', time: 180, inc: 2 },
  { name: '5+0', time: 300, inc: 0 },
  { name: '5+3', time: 300, inc: 3 },
  { name: '10+0', time: 600, inc: 0 },
  { name: '10+5', time: 600, inc: 5 },
  { name: '15+10', time: 900, inc: 10 },
  { name: '30+0', time: 1800, inc: 0 },
];

export function renderClock(): string {
  return `
    <div class="clock-page">
      <h1 class="page-title">⏱️ Jam Catur</h1>
      <p class="text-secondary mb-lg">Atur waktu permainanmu</p>

      <div id="clock-setup">
        <div class="card mb-md">
          <h3 class="settings-heading">Preset Waktu</h3>
          <div class="preset-grid">
            ${PRESETS.map(p => `
              <button class="btn btn-ghost btn-sm preset-btn" data-time="${p.time}" data-inc="${p.inc}">${p.name}</button>
            `).join('')}
          </div>
        </div>

        <div class="card mb-md">
          <h3 class="settings-heading">Custom</h3>
          <div class="setting-row">
            <label>Waktu (menit)</label>
            <input type="number" id="clock-minutes" class="clock-input" value="5" min="1" max="180" />
          </div>
          <div class="setting-row">
            <label>Increment (detik)</label>
            <input type="number" id="clock-increment" class="clock-input" value="0" min="0" max="60" />
          </div>
          <button class="btn btn-primary mt-md" id="btn-start-clock" style="width:100%">Mulai</button>
        </div>
      </div>

      <div id="clock-game" style="display:none">
        <div class="clock-board">
          <div class="clock-side clock-black" id="clock-black">
            <div class="clock-label">♚ Hitam</div>
            <div class="clock-time" id="black-time">5:00</div>
          </div>

          <div class="clock-middle">
            <div class="clock-status" id="clock-status">Tekan tombol untuk mulai</div>
            <div class="clock-controls">
              <button class="btn btn-ghost btn-sm" id="btn-pause-clock">⏸ Pause</button>
              <button class="btn btn-ghost btn-sm" id="btn-reset-clock">🔄 Reset</button>
              <button class="btn btn-ghost btn-sm" id="btn-back-setup">⚙️ Setting</button>
            </div>
          </div>

          <div class="clock-side clock-white" id="clock-white">
            <div class="clock-time" id="white-time">5:00</div>
            <div class="clock-label">♔ Putih</div>
          </div>
        </div>
      </div>
    </div>
  `;
}

export function initClock(): void {
  // Preset buttons
  document.querySelectorAll('.preset-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const time = parseInt((btn as HTMLElement).dataset.time!);
      const inc = parseInt((btn as HTMLElement).dataset.inc!);
      (document.getElementById('clock-minutes') as HTMLInputElement).value = String(time / 60);
      (document.getElementById('clock-increment') as HTMLInputElement).value = String(inc);
    });
  });

  // Start button
  document.getElementById('btn-start-clock')?.addEventListener('click', startClock);

  // Clock tap areas
  document.getElementById('clock-white')?.addEventListener('click', () => tapClock('w'));
  document.getElementById('clock-black')?.addEventListener('click', () => tapClock('b'));

  // Controls
  document.getElementById('btn-pause-clock')?.addEventListener('click', pauseClock);
  document.getElementById('btn-reset-clock')?.addEventListener('click', resetClock);
  document.getElementById('btn-back-setup')?.addEventListener('click', backToSetup);
}

function startClock(): void {
  const minutes = parseInt((document.getElementById('clock-minutes') as HTMLInputElement).value) || 5;
  increment = parseInt((document.getElementById('clock-increment') as HTMLInputElement).value) || 0;

  whiteTime = minutes * 60;
  blackTime = minutes * 60;
  activeSide = null;
  isRunning = false;

  document.getElementById('clock-setup')!.style.display = 'none';
  document.getElementById('clock-game')!.style.display = 'block';

  updateClockDisplay();
  document.getElementById('clock-status')!.textContent = 'Tekan jam untuk mulai (putih duluan)';
}

function tapClock(side: 'w' | 'b'): void {
  if (!isRunning && activeSide === null) {
    // First tap — start the opponent's clock
    activeSide = side === 'w' ? 'b' : 'w';
    isRunning = true;
    startInterval();
    updateClockStatus();
    return;
  }

  if (!isRunning) return;

  // Only the active side can tap
  if (side !== activeSide) return;

  // Add increment to the side that just moved
  if (side === 'w') {
    whiteTime += increment;
  } else {
    blackTime += increment;
  }

  // Switch to other side
  activeSide = side === 'w' ? 'b' : 'w';
  updateClockDisplay();
  updateClockStatus();
}

function startInterval(): void {
  if (clockInterval) clearInterval(clockInterval);
  clockInterval = setInterval(() => {
    if (!isRunning || !activeSide) return;

    if (activeSide === 'w') {
      whiteTime--;
      if (whiteTime <= 0) {
        whiteTime = 0;
        isRunning = false;
        clearInterval(clockInterval!);
        clockInterval = null;
        document.getElementById('clock-status')!.textContent = '⏰ Waktu Putih Habis! Hitam Menang!';
        playSoundSafe('gameover');
      }
    } else {
      blackTime--;
      if (blackTime <= 0) {
        blackTime = 0;
        isRunning = false;
        clearInterval(clockInterval!);
        clockInterval = null;
        document.getElementById('clock-status')!.textContent = '⏰ Waktu Hitam Habis! Putih Menang!';
        playSoundSafe('gameover');
      }
    }

    updateClockDisplay();
  }, 1000);
}

function pauseClock(): void {
  isRunning = false;
  if (clockInterval) {
    clearInterval(clockInterval);
    clockInterval = null;
  }
  document.getElementById('clock-status')!.textContent = '⏸ Paused — tekan jam untuk lanjut';
}

function resetClock(): void {
  isRunning = false;
  activeSide = null;
  if (clockInterval) {
    clearInterval(clockInterval);
    clockInterval = null;
  }
  backToSetup();
}

function backToSetup(): void {
  isRunning = false;
  activeSide = null;
  if (clockInterval) {
    clearInterval(clockInterval);
    clockInterval = null;
  }
  document.getElementById('clock-setup')!.style.display = 'block';
  document.getElementById('clock-game')!.style.display = 'none';
}

function updateClockDisplay(): void {
  const whiteEl = document.getElementById('white-time');
  const blackEl = document.getElementById('black-time');
  if (whiteEl) whiteEl.textContent = formatTime(whiteTime);
  if (blackEl) blackEl.textContent = formatTime(blackTime);

  // Highlight active side
  const whiteSide = document.getElementById('clock-white');
  const blackSide = document.getElementById('clock-black');
  if (whiteSide) whiteSide.classList.toggle('active', activeSide === 'w' && isRunning);
  if (blackSide) blackSide.classList.toggle('active', activeSide === 'b' && isRunning);

  // Warning when time is low
  if (whiteEl) whiteEl.classList.toggle('low', whiteTime <= 10 && whiteTime > 0);
  if (blackEl) blackEl.classList.toggle('low', blackTime <= 10 && blackTime > 0);
  if (whiteEl) whiteEl.classList.toggle('critical', whiteTime <= 0);
  if (blackEl) blackEl.classList.toggle('critical', blackTime <= 0);
}

function updateClockStatus(): void {
  const status = document.getElementById('clock-status');
  if (!status) return;
  if (activeSide === 'w') {
    status.textContent = '♔ Giliran Putih — tekan jam setelah bergerak';
  } else {
    status.textContent = '♚ Giliran Hitam — tekan jam setelah bergerak';
  }
}

function formatTime(seconds: number): string {
  if (seconds <= 0) return '0:00';
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${m}:${s.toString().padStart(2, '0')}`;
}

function playSoundSafe(name: string): void {
  try { playSound(name as any); } catch {}
}

function playSound(name: string): void {
  // Import dynamically to avoid circular deps
  import('../../audio/sound').then(m => m.playSound(name as any)).catch(() => {});
}
